import { render, staticRenderFns } from "./FormUpload.vue?vue&type=template&id=7032ceb5"
import script from "./FormUpload.vue?vue&type=script&lang=js"
export * from "./FormUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7032ceb5')) {
      api.createRecord('7032ceb5', component.options)
    } else {
      api.reload('7032ceb5', component.options)
    }
    module.hot.accept("./FormUpload.vue?vue&type=template&id=7032ceb5", function () {
      api.rerender('7032ceb5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/form/FormUpload.vue"
export default component.exports